import axios from "axios";
import { config_UPTIME } from "../Constants";
import { getItem } from "../utils/DataProtection";
import { extractChecklistReportsFromResponse } from "../utils/checklistMapper";

// Photos on answers are uploaded under the checklist's CURRENT in-progress
// report (uptime-backend issue #4): the file links the backend returns on read
// only resolve for that report's nodeid. Earlier photos sent along with a new
// report's answer are copied into it by the backend (!18).

/**
 * POST /checklists/:nodeid/reports/current: the current in-progress report,
 * created blank when there is none (uptime-backend !18). Idempotent until the
 * checklist is complete, so it is asked right before each upload — photos
 * then always go under the report their answer is saved into. With
 * `notificationNodeId` it is that Meldung's own report.
 * @returns {Promise<string>} the report's nodeid
 */
export async function startCurrentReport(checklistNodeId, notificationNodeId) {
  const { data } = await axios.post(
    `${config_UPTIME.url.API_URL}/checklists/${encodeURIComponent(checklistNodeId)}/reports/current`,
    notificationNodeId ? { notificationnodeid: notificationNodeId } : null,
    { headers: { Authorization: "Bearer " + JSON.parse(getItem("user")) } }
  );
  if (!data?.nodeid) throw new Error("reports/current returned no nodeid");
  return data.nodeid;
}

/** GET /checklists/:nodeid/reports — each photo comes with a fresh signed `url`. */
export async function fetchChecklistReports(checklistNodeId) {
  const { data } = await axios.get(
    `${config_UPTIME.url.API_URL}/checklists/${encodeURIComponent(checklistNodeId)}/reports`,
    { headers: { Authorization: "Bearer " + JSON.parse(getItem("user")) } }
  );
  return extractChecklistReportsFromResponse(data);
}
